export default {
  connected: '关联平台账号',
  perfectInfo: '完善账号信息',
  agree: '登录即表示您同意',
  confirm: '确定',
  haveAccount: '已有用户名？',
  noAccount: '没有平台账号'
}



// WEBPACK FOOTER //
// ./src/lang/zh/oauth.js